export default class AdminFormComponentProvider {
    //AdminFormShouldabeenhere
    getAdminComponent() {
        return <></>
    }
}